var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          staticClass: "update",
          attrs: { type: "primary", disabled: _vm.editDisabled },
          on: { click: _vm.clickUpdate }
        },
        [_vm._v("更新")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }